// import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import JwtService from '@/services/jwtService'
import jwtDefaultConfig from './jwtDefaultConfig'

const jwt = new JwtService(axios, jwtDefaultConfig)
export default jwt
